import { IDateType } from "../Dashboard/Types"

export enum ISearchActionTypes {
    GET_MEDIAS_TDP = '@@search/GET_MEDIAS_TDP',
    GET_MEDIAS_TDP_SUCCESS = '@@search/GET_MEDIAS_TDP_SUCCESS',
    GET_MEDIAS_TDP_ERROR = '@@search/GET_MEDIAS_TDP_ERROR',

    GET_PROGRAM_TYPES = '@@search/GET_PROGRAM_TYPES',
    GET_PROGRAM_TYPES_SUCCESS = '@@search/GET_PROGRAM_TYPES_SUCCESS',
    GET_PROGRAM_TYPES_ERROR = '@@search/GET_PROGRAM_TYPES_ERROR',

    GET_ELECTION_CAMPAIGN = '@@search/GET_ELECTION_CAMPAIGN',

    GET_PROGRAM_EDITORS = '@@search/GET_PROGRAM_EDITORS',
    GET_PROGRAM_EDITORS_SUCCESS = '@@search/GET_PROGRAM_EDITORS_SUCCESS',
    GET_PROGRAM_EDITORS_ERROR = '@@search/GET_PROGRAM_EDITORS_ERROR',
    
    GET_AUTOCOMPLETE_PERSON = '@@search/GET_AUTOCOMPLETE_PERSON',
    GET_AUTOCOMPLETE_PERSON_SUCCESS = '@@search/GET_AUTOCOMPLETE_PERSON_SUCCESS',
    GET_AUTOCOMPLETE_PERSON_ERROR = '@@search/GET_AUTOCOMPLETE_PERSON_ERROR',

    GET_MEDIAS_SOURCE = '@@search/GET_MEDIAS_SOURCE',
    GET_MEDIAS_SOURCE_SUCCESS = '@@search/GET_MEDIAS_SOURCE_SUCCESS',
    GET_MEDIAS_SOURCE_ERROR = '@@search/GET_MEDIAS_SOURCE_ERROR',

    GET_POLITICAL_GROUP_SPECIFIC = '@@search/GET_POLITICAL_GROUP_SPECIFIC',
    GET_POLITICAL_GROUP_SPECIFIC_SUCCESS = '@@search/GET_POLITICAL_GROUP_SPECIFIC_SUCCESS',
    GET_POLITICAL_GROUP_SPECIFIC_ERROR = '@@search/GET_POLITICAL_GROUP_SPECIFIC_ERROR',

    CLEAR_PERSONS_LIST = '@@search/CLEAR_PERSONS_LIST',
    RESET_DATA = '@@search/RESET_DATA',

    SAVE_FILTERS = '@@search/SAVE_FILTERS',
    RESET_FILTERS = '@@search/RESET_FILTERS',

    SAVE_TIME_SELECTION = '@@search/SAVE_TIME_SELECTION',
}
export interface ITimeSlotHour {
    identifiant: string,
    value: string,
    startTime: string,
    endTime: string
}
export const timeSlotsArr:ITimeSlotHour[] = [
    {
        identifiant: "all_day",
        value: "24h/24h",
        startTime: "00:00",
        endTime: "24:00"
    },
    {
        identifiant: "matin",
        value: "6h-9h",
        startTime: "06:00",
        endTime: "09:00"
    },
    {
        identifiant: "journee",
        value: "9h-18h",
        startTime: "09:00",
        endTime: "18:00"
    },
    {
        identifiant: "soiree",
        value: "18h-24h",
        startTime: "18:00",
        endTime: "24:00"
    },
    {
        identifiant: "nuit",
        value: "0h-6h",
        startTime: "00:00",
        endTime: "06:00"
    },

]
export interface ISearchFilters {
    media_ids: number[],
    media_str: string[] | null,
    program_types_ids: number[],
    program_types_str: string[] | null,
    start_date: Date,
    end_date: Date,
}
export interface ITimeFilters {
  dateType: IDateType;
  endDate: Date;
  endSlot: Date;
  isFullYearSelected: boolean;
  isSem1Activated: boolean;
  isSem2Activated: boolean;
  isTrim1Selected: boolean;
  isTrim2Selected: boolean;
  isTrim3Selected: boolean;
  isTrim4Selected: boolean;
  selectedMonthIndex: number;
  selectedYear: number;
  startDate: Date;
  startSlot: Date;
}

export interface IAuthorizedMedia {
    media_id: number,
    nomfiche: string,
    start_date: string
    end_date: string,
    advancement_date: string
}
export interface IMedia {
    id: number;
    name: string;
    type?: number;
}

export interface IProgramType {
    id: number;
    name: string;
    code_csa: string;
}
export interface IProgramEditor {
    id: number;
    name: string;
}
export type IGenrePerson = "Femme" | "Homme"

export const initialAutocompletePerson:IAutocompletePerson = {
    first_name: null,
    genre_id: -1,
    genre_name: "Homme",
    id: -1,
    index_name: '',
    index_social_reason: null,
    is_csa: -1,
    last_name: '',
    name_csa: '',
    social_reason: null
}
export interface IAutocompletePerson {
    first_name: string | null,
    genre_id: number,
    genre_name: IGenrePerson,
    id: number,
    index_name: string,
    index_social_reason: any,
    is_csa: number,
    last_name: string,
    name_csa: string,
    social_reason: any
}
export interface IPoliticalGroupSpecific {
    political_group_color: number,
    political_group_id: number,
    political_group_name: string
}
export interface IPoliticalGroupSpecificSimple {
    color: number,
    id: number,
    name: string
}
export interface ISearchState {
    readonly programTypes: IProgramType[];
    readonly allProgramTypesID: number[];
    readonly allProgramTypesSTR: string[];
    readonly programEditors: IProgramEditor[];
    readonly allProgramEditorsID: number[] | null;
    readonly allProgramEditorsSTR: string[];
    readonly politicalGroup: IPoliticalGroupSpecificSimple[];
    readonly allPoliticalGroupID: number[];
    readonly allPoliticalGroupSTR: string[];
    readonly autocompletePersonList: IAutocompletePerson[];
    readonly mediasSource: any;
    readonly isLoading: boolean; 
    readonly isPersonAutocompleteLoading: boolean;
    readonly searchFilters: ISearchFilters | null;
    readonly timeFilters: ITimeFilters | null;
    readonly elections: any[];
    readonly allElectionsID: number[];
    readonly allElectionsSTR: string[];
}
